import './App.css';
import { Grid } from 'semantic-ui-react'
import { Header } from './components/Header/Header';
import { Footer } from './components/Footer/Footer';
import { Content } from './components/Content/Content';
import { LocaleProvider, useLocale } from './contexts/LocaleContext';
import { translations } from './translations';
import { IntlProvider } from 'react-intl';

function App() {
  return (
    <LocaleProvider>
      <AppContent />
    </LocaleProvider>
  );
}

function AppContent() {
  const { locale } = useLocale();
  
  return (
    <IntlProvider messages={translations[locale]} locale={locale}>
      <div className="App">
        <Grid container stackable>
          <Header />
          <Content />
          <Footer />
        </Grid>
      </div>      
    </IntlProvider>

  );
}

export default App;
